import { ref } from 'vue'

export const DEV_ELECTRON_OVERRIDE_KEY = '__driver_v2_dev_electron_override__'

const electronOverride = ref<boolean | null>(null)
let electronOverrideInitialized = false

const detectElectron = () => {
  return (typeof process !== 'undefined' && process.versions != null && process.versions.electron != null) || (typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Electron') !== -1)
}

const canUseDevEnvUi = () => {
  return true
  if (typeof window === 'undefined') {
    return false
  }

  if (import.meta.env.VITE_ENABLE_DEBUG_UI === 'true') {
    return true
  }

  if (!import.meta.env.DEV) {
    return false
  }

  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
}

/**
 * 是否是开发环境或内部测试构建版本 (非 production 打包)
 * 使用常量以便 Vite 在打包时进行死代码消除 (Tree-shaking)
 */
export const IS_INTERNAL_BUILD = import.meta.env.MODE !== 'production'

const normalizeElectronOverride = (value?: string | null) => {
  if (value === 'true') {
    return true
  }

  if (value === 'false') {
    return false
  }

  return null
}

const ensureElectronOverride = () => {
  if (electronOverrideInitialized) {
    return electronOverride.value
  }

  electronOverrideInitialized = true
  if (!canUseDevEnvUi() || typeof localStorage === 'undefined') {
    electronOverride.value = null
    return electronOverride.value
  }

  electronOverride.value = normalizeElectronOverride(localStorage.getItem(DEV_ELECTRON_OVERRIDE_KEY))
  return electronOverride.value
}

export const canShowDevUi = () => {
  return canUseDevEnvUi()
}

export const getDetectedElectron = () => {
  return detectElectron()
}

export const getDevElectronOverride = () => {
  return ensureElectronOverride()
}

export const setDevElectronOverride = (value?: boolean | null) => {
  if (!canUseDevEnvUi() || typeof localStorage === 'undefined') {
    return isElectron()
  }

  if (value === null || value === undefined) {
    localStorage.removeItem(DEV_ELECTRON_OVERRIDE_KEY)
    electronOverride.value = null
    return isElectron()
  }

  localStorage.setItem(DEV_ELECTRON_OVERRIDE_KEY, value ? 'true' : 'false')
  electronOverride.value = value
  return isElectron()
}

export const isElectron = () => {
  const override = ensureElectronOverride()
  return override === null ? detectElectron() : override
}

export const isWebHIDSupported = () => {
  return 'hid' in navigator
}
